import React,{useState, useEffect} from "react";
import { API } from '../../../services/api';
import { Link, useHistory } from 'react-router-dom';
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import ImgLoading from '../../../assets/cargacaleta.gif';
import "./UserRequests.scss";

export function UserRequestsPage() {
  /**
   * Vistar de solicitudes de usuarios
   * Se consulta el listado de usuario que tienen solicitudes pendientes
   * al cargar se renderiza una tabla con los datos de los usuarios
   */
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }

  useEffect(() => {
    protectedRoute();
    setLoading(true);
    /**
     * Obtener usuarios pendientes
     * se hace el llamado al servicio /users/get-pending-users
     */
    API.getPendingUsers()
      .then(res => {
        setUsers(res);
        setLoading(false);
      })
      .catch(err => {
        setUsers([]);
        setLoading(false);
      })
  }, []);

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Solicitudes de usuarios</h2>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>RUT</th>
                <th>Email</th>
                <th>Teléfono</th>
                <th>Región</th>
                <th>Comuna</th>
                <th>Caleta</th>
                <th>Tipo De Identificador</th>
                <th>Fecha De Solicitud</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                users.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.lastname}</td>
                    <td>{item.rut}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>{item.regionKey}</td>
                    <td>{item.communeKey}</td>
                    <td>{item.caletaKey}</td>
                    <td>Pescador: {item.typeKey}</td>
                    <td>{new Date(item._modifyTimestamp).toLocaleDateString()}</td>
                    <td>
                      <Link 
                        className='link-detail' 
                        to={{
                          pathname:'user-profile',
                          search: `?userId=${item._id}`
                        }}>
                        Ver</Link>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </main>
    </>
  )
}